// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__flH97","content":"styles_content__3G0b1"};